import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
const STATUS_MAP = {
    AVAILABLE: 'available',
    DRIVING: 'driving',
    RESTING: 'resting',
    WORKING: 'working',
};
const icons = {
    [STATUS_MAP.AVAILABLE]: 'rioglyph-status-available',
    [STATUS_MAP.WORKING]: 'rioglyph-status-working',
    [STATUS_MAP.DRIVING]: 'rioglyph-status-driving',
    [STATUS_MAP.RESTING]: 'rioglyph-status-resting',
};
const SIZE_MAP = { SIZE_SM: 'sm', SIZE_LG: 'lg', SIZE_XL: 'xl' };
const Activity = forwardRef((props, ref) => {
    const { activity, duration, isOutdated = false, bsSize, onClick = () => { }, className = '', ...remainingProps } = props;
    if (!activity) {
        return null;
    }
    const wrapperClassNames = classNames('activity', `activity-${activity}`, isOutdated && 'opacity-50', bsSize && `activity-${bsSize}`, className && className);
    return (_jsxs("div", { ref: ref, ...remainingProps, className: wrapperClassNames, onClick: onClick, children: [_jsx("span", { className: 'activity-icon', children: _jsx("span", { className: `rioglyph ${icons[activity]}` }) }), duration && _jsx("span", { className: 'activity-text', children: duration })] }));
});
// statics
Object.assign(Activity, STATUS_MAP);
Object.assign(Activity, SIZE_MAP);
export default Activity;
